import React, { FC, memo } from 'react';
import { DivCircle, DivColor } from './styles';

type Props = {
  color: string;
};

const FnColorCircle: FC<Props> = ({ color }) => {
  return (
    <DivColor>
      <DivCircle color={color || ''} />
      <span>{color}</span>
    </DivColor>
  );
};

export default memo(FnColorCircle);
